var React = require('react');

function PowerLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.407.087a1 1 0 01.569 1.13L25.246 18H40a1 1 0 01.813 1.581l-20 28a1 1 0 01-1.79-.798L22.754 30H8a1 1 0 01-.814-1.581l20-28a1 1 0 011.221-.332zM9.943 28H24a1 1 0 01.976 1.217L22.042 42.42 38.057 20H24a1 1 0 01-.976-1.217L25.958 5.58 9.943 28z"}));
}

PowerLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PowerLight;

PowerLight.default = PowerLight;
